import { render, staticRenderFns } from "./ResultsViewChart.vue?vue&type=template&id=604e87f7&"
import script from "./ResultsViewChart.vue?vue&type=script&lang=ts&"
export * from "./ResultsViewChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports